import React, { Fragment } from 'react';
import { CompanyLogo } from '@components';
import { BOTTOM_INDENTS } from '@constants';
import { ACCOUNT_USER_ROLE } from '@enums';
import { useStore } from '@hooks';
import { observer } from 'mobx-react';
import StyledMenu from './components/Menu';

const SideBar = observer(() => {
    const store = useStore();
    const { me } = store.authStore;
    const isDeveloper = me?.permission?.role === ACCOUNT_USER_ROLE.DEVELOPER;

    return (
        <Fragment>
            {!isDeveloper && <CompanyLogo style={BOTTOM_INDENTS.XL_PLUS} />}
            <StyledMenu />
        </Fragment>
    );
});

export default SideBar;
